import {useEffect, useRef, useState} from 'react';
import {useNivelesEstructure} from "hooks/useNivelesEstructure";

import Search from "components/NivelesEstructure/Search";
import Form from "components/NivelesEstructure/Form";
import Table from "components/NivelesEstructure/Table";
import SpinnerBootrap from 'components/SpinnerBootrap';

function NivelesEstructure(){
 const {
    nivelesEstructure, 
    loading, 
    page, 
    totalPages, 
    status, 
    deleteNivelEstructure, 
    updateNivelEstructure, 
    createNivelEstructure, 
    getNivelesEstructure, 
    setPage,
    itemsPerPage,
    setItemsPerPage,
    allNivelesEstructure,
} = useNivelesEstructure();

 const [isSearched, setIsSearched] = useState({
     search: '',
     option: '',
     state: false
 })
 
 const searchFormRef = useRef();
     
 const resetSearch = () => {
    setIsSearched({
        search: '',
        option: '',
        state: false
    })
    searchFormRef.current?.reset();
 }
 useEffect(() => {
    if(status !== 401 ) return
    localStorage.removeItem('token')
    window.location.href="/login"
 }, [status])

 return (
 <div className="container">
     <div className="row my-md-4">
         <h4 className="d-flex justify-content-center">Niveles Estructure</h4>
         <div className="col-12">
             <Search
                getNivelesEstructure={getNivelesEstructure}
                setIsSearched={setIsSearched}
                formRef={searchFormRef}
             />
         </div>
         <div className="col-12">
             <Form createNivelEstructure={createNivelEstructure} updateNivelEstructure={updateNivelEstructure} setIsSearched={setIsSearched}/>
         </div>
         <div className="col-12">
             {loading && <SpinnerBootrap/>}
             <Table
                nivelesEstructure={nivelesEstructure}
                getNivelesEstructure={getNivelesEstructure}
                deleteNivelEstructure={deleteNivelEstructure}
                totalPages={totalPages}
                setPage={setPage}
                page={page}
                isSearched={isSearched}
                setIsSearched={setIsSearched}
                hasSearched={isSearched.state}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage} 
                resetSearch={resetSearch}
                totalNivelesEstructure={allNivelesEstructure.length ?? 0}
             />
        </div>
     </div>
 </div>
 )
}

export default NivelesEstructure